import Image from 'next/image'
import type { ComponentProps } from 'react'

export const Logo = (props: Omit<ComponentProps<typeof Image>, 'src' | 'alt' | 'placeholder' | 'blurDataURL'>) => (
  <Image
    {...props}
    placeholder='blur'
    alt='RTSC logo image'
    src='/images/rtsc_logo_330x148.png'
    blurDataURL='data:image/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAMAAADNLv/0AAAAAXNSR0IB2cksfwAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAK5QTFRFwsHBoZKSw7e29+np9+zs+Pb27evr/fz87+7u+/z8l4iIjQ4JoQkM14WCymZjpoWEk42Ns7Kyc3Fxvby8momJnAsLnwkM2dnZzZWVwry8kI6PlpSV19bX5+bmk4mIWRANbSso3dzcz7a2uLe4lJOTwcDBi4mKzMvM19bWzcLC7OXk/fDw8vLy7+/v9PX18PDw8fLy/f39//39/enn/ezq/eHf5+Xl4eHh5eXl39/fu+ppxwAAABxJREFUeJxjZGCEAy4EUwTBlEMwNRBMIyj9/yIAGUQCoeTy7I8AAAAASUVORK5CYII='
  />
)
